const PropTypes = require('prop-types');
const React = require('react');
const { isEqual, map, each, isEmpty, cloneDeep, merge, set, every, find } = require('lodash');
const { connect } = require('react-redux');

// @ helpers
const { stringToBoolean } = require('utilities/stringHelper');

// @ components
const { InputSafe } = require('commonsComponents/inputSafe');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { OKInput } = require('commonsComponents/OKInput');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const address = require('./address');
const registralData = require('./registralData');

// @ constants
const { text, addressData, addRegData, MAP_DATA, TYPE_OF_ROADS, dataTypes } = require('../initialValues');
const { ESTATE_REGISRATION_TYPE } = require('constants/mortgageRequestEstates');

// @ actions
const getLocationData = require('actions/mortgageRequest/mortgageRequestLocationData');

class AdditionalEstateInfo extends React.Component {
    constructor(props) {
        super(props);
        this.isPart = true;
        this.additionalOption = '';
        this.cruData = '';
        this.errorCruData = false;
        this.sameLivingPlaceAdress = false;
        this.addressData = cloneDeep(addressData);
        this.registralData = cloneDeep(addRegData);

        this.estateNumberSameLivingPlace = '';
        this.estateNumberSameLivingPlaceError = false;

        this.handleChangeIsPart = this.handleChangeIsPart.bind(this);
        this.handleChangeAdditionalOption = this.handleChangeAdditionalOption.bind(this);
        this.handleChangeData = this.handleChangeData.bind(this);
        this.handleChangeCruData = this.handleChangeCruData.bind(this);
        this.handleChangeSameLivingPlace = this.handleChangeSameLivingPlace.bind(this);
        this.buildData = this.buildData.bind(this);
        this.handleChangeEstateNumberLivingPlace = this.handleChangeEstateNumberLivingPlace.bind(this);
    }

    componentWillMount() {
        this.props.onBuildData(this.buildData);

        if (!isEmpty(this.props.estateData) || this.props.isPartLivingPlace) {

            this.setInfo();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (
            !isEqual(this.props.estateData, nextProps.estateData)
            ||
            !isEqual(this.props.isPartLivingPlace, nextProps.isPartLivingPlace)
        ) {
            this.setInfo(nextProps);
        }
    }

    componentWillUnmount() {
        this.props.onBuildData(undefined);
    }

    setInfo(nextProps) {
        const props = nextProps || this.props;
        if (props.isPartLivingPlace) {
            this.isPart = true;
            return false;
        }

        this.isPart = false;

        this.additionalOption =
            props.estateData.idType === ESTATE_REGISRATION_TYPE.REG ? dataTypes.REG_DATA :
                props.estateData.idType === ESTATE_REGISRATION_TYPE.DIR ? dataTypes.ADDRESS : props.estateData.idType;

        if (this.additionalOption === dataTypes.ADDRESS) {
            this.sameLivingPlaceAdress = this.validateSameAddressLivingPlace();

            if (this.sameLivingPlaceAdress) {
                this.estateNumberSameLivingPlace = this.props.estateData.addressOthers || this.props.estateData.streetBlock;
            }
        }

        if (this.additionalOption === dataTypes.CRU) {
            this.cruData = props.estateData.idufir;
        }

        props.estateData.populationList && this.setPopulationData(props.estateData.populationList);
        props.estateData.registerList && this.setRegistersData(props.estateData.registerList);

        const typeOfRoad = find(TYPE_OF_ROADS, { value: props.estateData.streetType });

        const addressData = {
            fields: {
                typeOfRoad,
                province: props.estateData.provinceData,
                population: props.estateData.populationData,
                roadName: props.estateData.street,
                numberStreet: props.estateData.streetNumber.toString(),
                another: props.estateData.addressOthers || props.estateData.streetBlock,
                postalCode: props.estateData.postalCode
            },
        };

        const registralData = {
            fields: {
                province: props.estateData.provinceData,
                population: props.estateData.populationData,
                registerName: props.estateData.registerData,
                estateNumber: props.estateData.registerFincaNumber,
                estateSection: props.estateData.registerSection,
                estateBook: props.estateData.registerBook,
                estateVolume: props.estateData.registerVolume,
                estateFolio: props.estateData.registerFolio
            },
        };

        this.addressData = merge(this.addressData, addressData);
        this.registralData = merge(this.registralData, registralData);
    }

    setPopulationData(populationList = false) {

        if (populationList) {
            this.population = map(populationList, population => ({ label: population.name, value: population.id }));

        } else {
            const { idx, type, mortgageRequestLocationData } = this.props;
            const formId = `${idx}${type}`;
            const populationData = mortgageRequestLocationData.get('populationData').toJS();
            const stateFormId = populationData.formItemId


            if (formId === stateFormId) {
                this.population = populationData.populationsList && populationData.populationsList.map(data => ({ label: data.name, value: data.id }));
            }
        }
    }

    setProvincesData() {
        const { mortgageRequestLocationData } = this.props;
        this.provinces = mortgageRequestLocationData.get('provincesList').toJS().map(data => ({ label: data.name, value: data.id }));
    }

    setRegistersData(registersList = false) {

        if (registersList) {
            this.registers = map(registersList, register => ({ label: register.name, value: register.id }));

        } else {

            const { idx, type, mortgageRequestLocationData } = this.props;
            const formId = `${idx}${type}`;
            const registersData = mortgageRequestLocationData.get('registersData').toJS();
            const stateFormId = registersData.formItemId

            if (formId === stateFormId) {
                this.registers = registersData.registersList && registersData.registersList.map(data => ({ label: data.name, value: data.id }));
            }

        }
    }

    buildAddress() {
        if (this.additionalOption === dataTypes.ADDRESS) {

            const addressOptions = {
                another: {
                    label: 'NUMBER_LABEL'
                }
            };

            const addressParameters = {
                data: this.addressData,
                provinces: this.provinces,
                population: this.population,
                onChange: this.handleChangeData
            };

            const adressData = !this.sameLivingPlaceAdress ? address(addressParameters, addressOptions) :
                this.buildEstateNumberSameLivingPlace();

            return (
                <div className="row mortgage-request-estates__row-child">
                    <div className="col-xs-12">
                        <OKCheckbox
                            idName={`chkBox-${this.props.type}-${this.props.idx}`}
                            label={text().ANOTHER_ESTATES.ADDITIONAL.SAME_ADDRESS}
                            value={this.sameLivingPlaceAdress}
                            onChange={this.handleChangeSameLivingPlace}
                        />
                    </div>
                    <br />
                    <div className="row">
                        {adressData}
                    </div>
                </div>
            );
        }
    }

    buildCru() {
        if (this.additionalOption === dataTypes.CRU) {

            return (
                <div className="row mortgage-request-estates__row-child">
                    <div className="col-xs-7">
                        <OKInput
                            onChange={this.handleChangeCruData}
                            errorMessage={text().MESSAGES.REQUIRED}
                            errorState={this.errorCruData}
                            maxLength={14}
                            value={this.cruData}
                        />
                    </div>
                    <br />
                </div>
            );
        }
    }

    buildData() {
        const newMap = {};

        if (this.isPart) {
            if (this.props.estateData.id && !this.props.isPartLivingPlace) {
                newMap.id = this.props.estateData.id;
                newMap.delete = true;
            }
            return newMap;
        }

        if (!this.validateFields()) {
            return false;
        }

        each(MAP_DATA, (valueMap, keyMap) => {
            newMap[keyMap] = valueMap.default;
            each(this.addressData.fields, (valueAddress, keyAddress) => {

                if (keyAddress === valueMap.field) {

                    if (typeof valueAddress === 'object') {

                        if (valueAddress.value !== '') {
                            newMap[keyMap] = valueAddress.value;
                        }
                    } else {
                        newMap[keyMap] = valueAddress;
                    }
                }
            });

            each(this.registralData.fields, (valueRegData, keyRegData) => {

                if (keyRegData === valueMap.field) {

                    if (typeof valueRegData === 'object') {

                        if (valueRegData.value !== '') {
                            newMap[keyMap] = valueRegData.value;
                        }
                    } else {
                        newMap[keyMap] = valueRegData;
                    }
                }
            });
        });

        newMap.type = this.props.type;
        newMap.propertyType = this.props.type;
        newMap.idtype = this.additionalOption;
        newMap.idufir = this.cruData;

        if (this.props.estateData.id) {
            newMap.id = this.props.estateData.id;
            newMap.simpleNoteFlag = this.props.estateData.simpleNoteFlag;
        }

        if (this.sameLivingPlaceAdress) {
            newMap.sameLivingPlaceAdress = true;
            newMap.estateNumberSameLivingPlace = this.estateNumberSameLivingPlace;
        }

        return newMap;
    }

    buildEstateNumberSameLivingPlace() {
        const textValue = text();
        return (
            <div className="col-xs-4 mortgage-request-estates__number-same-living-place">
                <InputSafe
                    label={textValue.LABEL.NUMBER_LABEL}
                    name="another"
                    type="text"
                    value={this.estateNumberSameLivingPlace}
                    onChange={evt => this.handleChangeEstateNumberLivingPlace(evt.target.value)}
                    errorMessage={textValue.MESSAGES.REQUIRED}
                    errorState={this.estateNumberSameLivingPlaceError}
                />
            </div>
        );
    }

    buildNotPartOption() {
        if (!this.isPart) {

            return (
                <div className="col-xs-12">
                    <h2>{text().ANOTHER_ESTATES.ADDITIONAL.SELECT_OPTION}</h2>
                    <br />
                    {this.buildRadioButton(dataTypes.ADDRESS)}
                    {this.buildAddress()}
                    {this.buildRadioButton(dataTypes.CRU)}
                    {this.buildCru()}
                    {this.buildRadioButton(dataTypes.REG_DATA)}
                    {this.buildRegData()}
                </div>
            );
        }
    }

    buildRadioButton(formType) {
        const { idx, type } = this.props;
        return (
            <div className="row">
                <div className="col-xs-12">
                    <RadioButton
                        id={`radioButtonAditionalEstateInfo-${type}-${idx}-${formType}`}
                        name={`radioButtonAditionalEstateInfo-${type}-${idx}`}
                        label={text().ANOTHER_ESTATES.ADDITIONAL.OPTIONS[formType]}
                        value={formType}
                        onChange={this.handleChangeAdditionalOption}
                        isChecked={this.additionalOption === formType}
                        className="block-step__radio"
                    />
                </div>
            </div>
        );
    }

    buildRegData() {
        if (this.additionalOption === dataTypes.REG_DATA) {
            const registralParameters = {
                data: this.registralData,
                provinces: this.provinces,
                population: this.population,
                registers: this.registers,
                onChange: this.handleChangeData
            };

            return (
                <div className="row mortgage-request-estates__row-child">
                    {registralData(registralParameters)}
                </div>
            );
        }
    }

    handleChangeAdditionalOption(value) {
        if (value === dataTypes.REG_DATA && this.props.estateData.registerData) {
            this.registralData.fields.registerName = this.props.estateData.registerData;
        }

        this.additionalOption = value;
        this.forceUpdate();
    }

    handleChangeCruData(evt) {
        const nonNumericRegex = /^[^0-9]|[^\d]+/g;

        this.cruData = evt.target.value.replace(nonNumericRegex, '').trim();
        this.forceUpdate();
    }

    handleChangeData(name, value) {

        if (name === 'province' && value.length !== 0) {

            set(this.addressData, ['fields', name], value);
            set(this.registralData, ['fields', name], value);
            const addressFormId = `${this.props.idx}${this.props.type}`;

            this.props.requestLocationData(value.value, undefined, addressFormId);

        } else if (name === 'population' && value.length !== 0) {

            set(this.registralData, ['fields', name], value);
            set(this.addressData, ['fields', name], value);

            const addressFormId = `${this.props.idx}${this.props.type}`;
            const provinceId = this.registralData.fields.province.value;

            this.props.requestLocationData(provinceId, value.value, addressFormId);

        } else if (name === 'postalCode') {
            const postalCodeFormat = /[^0-9]|[^\d]+$/g;

            set(this.addressData, ['fields', name], value.replace(postalCodeFormat, '').trim());

        } else {

            this.additionalOption === dataTypes.ADDRESS && set(this.addressData, ['fields', name], value);

            this.additionalOption === dataTypes.REG_DATA && set(this.registralData, ['fields', name], value);
        }



        this.forceUpdate();
    }

    handleChangeEstateNumberLivingPlace(value) {
        this.estateNumberSameLivingPlace = value;
        this.estateNumberSameLivingPlaceError = false;
        this.forceUpdate();
    }

    handleChangeIsPart(isPart) {
        this.isPart = stringToBoolean(isPart);
        this.forceUpdate();
    }

    handleChangeSameLivingPlace(evt) {
        this.sameLivingPlaceAdress = evt.target.checked;

        this.forceUpdate();
    }

    validateFields() {
        let ok = true;

        if (this.additionalOption === dataTypes.CRU) {
            this.errorCruData = this.cruData === '' || this.cruData.length !== 14;
            ok = !this.errorCruData;
        }

        if (this.additionalOption === dataTypes.REG_DATA) {
            map(this.registralData.fields, (field, key) => {
                set(this.registralData, `validation.${key}`, typeof field === 'object' ? field.value === '' : field === '');
            });

            ok = every(this.registralData.validation, val => val === false);
        }

        if (this.additionalOption === dataTypes.ADDRESS) {

            if (this.sameLivingPlaceAdress) {

                if (this.estateNumberSameLivingPlace === '') {
                    this.estateNumberSameLivingPlaceError = true;
                    return false;
                }
            } else {

                map(this.addressData.fields, (field, key) => {
                    set(this.addressData, `validation.${key}`, typeof field === 'object' ? field.value === '' : field === '');
                });

                ok = every(this.addressData.validation, val => val === false);
            }
        }

        return ok;
    }

    validateSameAddressLivingPlace() {
        const { livingPlaceAddressData, estateData } = this.props;

        if (livingPlaceAddressData.streetType !== estateData.streetType) {
            return false;
        }

        if (livingPlaceAddressData.street !== estateData.street) {
            return false;
        }

        if (livingPlaceAddressData.streetNumber !== estateData.streetNumber) {
            return false;
        }

        if (livingPlaceAddressData.provinceId !== estateData.provinceId) {
            return false;
        }

        if (livingPlaceAddressData.populationId !== estateData.populationId) {
            return false;
        }

        if (livingPlaceAddressData.postalCode !== estateData.postalCode) {
            return false;
        }
        return true;
    }

    render() {
        const { idx, type } = this.props;
        const textValue = text();
        this.setProvincesData();
        this.setPopulationData();
        this.setRegistersData();

        return (
            <div className="row">
                <div className="col-xs-12">
                    <RadioButtonGroup
                        idPrefix={`radioButtonAdditionalEstatesOptions-${type}-${idx}`}
                        name={`radioButtonAdditionalEstatesOptions-${type}-${idx}`}
                        selectedValue={this.isPart}
                        onChange={this.handleChangeIsPart}
                        className="account-cancel-chequebook-step__radio-group"
                    >
                        <RadioButton label={textValue.ANOTHER_ESTATES.ADDITIONAL.IS_PART} value className="block-step__radio" />
                        <RadioButton label={textValue.ANOTHER_ESTATES.ADDITIONAL.IS_NOT_PART} value={false} className="block-step__radio" />
                    </RadioButtonGroup>
                </div>
                {this.buildNotPartOption()}
            </div>
        );
    }
}

AdditionalEstateInfo.propTypes = {
    idx: PropTypes.number,
    type: PropTypes.string,
    onBuildData: PropTypes.func,
    estateData: PropTypes.object,
    livingPlaceAddressData: PropTypes.object,
    isPartLivingPlace: PropTypes.bool,
    requestLocationData: PropTypes.func,
    mortgageRequestLocationData: PropTypes.object
}

module.exports.constructor = AdditionalEstateInfo;
module.exports.AdditionalEstateInfo = connect(
    state => ({
        mortgageRequestLocationData: state.mortgageRequestLocationData,
    }), {
        requestLocationData: getLocationData.requestLocationData
    })(AdditionalEstateInfo);
